module.exports = __webpack_public_path__ + "static/equipment-cityair-e3ca7e2d0a327922bc1b48c01a1d47f0.jpg";